// @flow

import merge from './utils/merge'
import strMap from './utils/strMap'

export {
    merge,
    strMap
}
